import { LitElement, html, css } from 'lit';

class MetalyxSectionHeading extends LitElement {
  static properties = {
    heading: { type: String },
    subheading: { type: String },
    align: { type: String },
  };

  static styles = css`
    :host {
      display: block;
      margin-bottom: 3rem;
    }
    .wrap {
      text-align: center;
    }
    :host([align="left"]) .wrap {
      text-align: left;
    }
    h2 {
      font-family: var(--font-heading, 'Outfit', sans-serif);
      font-size: var(--text-4xl, 2.25rem);
      font-weight: 700;
      color: var(--color-text-heading, #fff);
      margin: 0 0 0.75rem;
      line-height: 1.2;
    }
    .accent-line {
      width: 48px;
      height: 3px;
      background: var(--color-accent, #7C3AED);
      border-radius: 2px;
      margin: 0 auto 1rem;
    }
    :host([align="left"]) .accent-line {
      margin-left: 0;
    }
    p {
      font-family: var(--font-sans, 'DM Sans', sans-serif);
      font-size: var(--text-lg, 1.125rem);
      color: var(--color-text-muted, #64748B);
      margin: 0;
      max-width: 600px;
      line-height: 1.7;
    }
    .wrap:not([style]) p {
      margin-left: auto;
      margin-right: auto;
    }
    :host([align="left"]) p {
      margin-left: 0;
      margin-right: 0;
    }

    @media (max-width: 640px) {
      h2 {
        font-size: var(--text-3xl, 1.875rem);
      }
    }
  `;

  constructor() {
    super();
    this.heading = '';
    this.subheading = '';
    this.align = 'center';
  }

  render() {
    return html`
      <div class="wrap">
        <h2>${this.heading}</h2>
        <div class="accent-line"></div>
        ${this.subheading ? html`<p>${this.subheading}</p>` : ''}
      </div>
    `;
  }
}

customElements.define('metalyx-section-heading', MetalyxSectionHeading);